import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: 'flex',
        direction: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress id={'loader'} />
    </Box>
  );
};

export default Loader;
